import {observer} from "mobx-react";
import {AppBar, Toolbar, Tabs, Tab, Tooltip, Box, Paper, useTheme} from "@mui/material";
import useFeature from "../../useFeature";
import TabsPanelFeature from "./TabsPanelFeature";
import LayoutContentWrapper from "../layout/LayoutContentWrapper";
import commitPendingFieldEdits from "../../forms/commitPendingFieldEdits";


function TabsPanel({tabs, variant}) {
	const theme = useTheme();
	const feature = useFeature(() => new TabsPanelFeature(tabs));
	
	const isFeatureReady = (feature) => {
		return feature && feature.loaded
	}
	
	const changeTabSelection = (event, value) => {
		commitPendingFieldEdits();
		feature.changeTab(value);
	}

	const renderTabsBar = () => {
		if (feature.hasTabs()) {
			return (
				<Tabs
					value={feature.getSelectedTabId()}
					onChange={changeTabSelection}
					variant={variant || 'scrollable'}
					textColor={'inherit'}
					aria-label="edition tabs"
					scrollButtons="auto"
					allowScrollButtonsMobile
					sx={{
						'& .MuiTabs-indicator': {
							backgroundColor: theme.palette.primary.main
						},
						'& .MuiTab-root:not(:last-child)': {
							borderRight: '1px solid',
							borderColor: 'divider',
						},
						'& .MuiTab-root': {
							minHeight: 0,
							py: 1,
							px: 2,
							color: theme.palette.text.primary
						}
					}}
				>
					{renderTabOptions()}
				</Tabs>
			);
		}
		return <></>;
	}

	const renderTabOptions = () => {
		return feature.getTabOptions().map((tabOption) => {
			return (
				<Tooltip title={tabOption.title} key={tabOption.value}>
					<Tab
						label={tabOption.label}
						icon={tabOption.icon}
						value={tabOption.value}
						iconPosition={'start'}
						sx={{
							'&.Mui-selected': {
								color: theme.palette.primary.main
							}
						}}
					/>
				</Tooltip>
			);
		});
	}

	const renderSelectedTabPanel = () => {
		const current = feature.getCurrentTab();
		if (!current) return null;
		return current.panel ? current.panel() : null;
	}

	const renderContent = () => {
		return (
			<>
				<AppBar
					position="static"
					color="default"
					elevation={0}
					dir={"row"}
					sx={{
						'&.MuiAppBar-colorDefault': {
							backgroundColor: 'transparent',
							color: 'text.primary',
						},
						borderBottom: '0.5px solid',
						borderColor: 'divider',
					}}
				>
					<Toolbar variant="dense" sx={{ px: 0, minHeight: 'auto', ml: -2 }}>
						{renderTabsBar()}
					</Toolbar>
				</AppBar>
				<Box p={2}>
					<Paper elevation={0}>
						{renderSelectedTabPanel()}
					</Paper>
				</Box>
			</>
		);
	}

	return (
		<LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={renderContent}/>
	);
}

export default observer(TabsPanel)